import { render, staticRenderFns } from "./campos_dados.vue?vue&type=template&id=00e0cf84&scoped=true&"
import script from "./campos_dados.vue?vue&type=script&lang=js&"
export * from "./campos_dados.vue?vue&type=script&lang=js&"
import style0 from "./campos_dados.vue?vue&type=style&index=0&id=00e0cf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0cf84",
  null
  
)

export default component.exports